import React from 'react'
import { BrandCard } from '@/components/molecules/BrandCard'
import './BrandsSection.css'

import noiseTexture from '@/assets/85fe266e0c6fb628db33db1060a8f41f96030503.png'

import properrLogo from '@/assets/properr_logo.png'
import auditzyLogo from '@/assets/auditzy_logo.png'
import triptureLogo from '@/assets/tripture_logo.png'
import wiingyLogo from '@/assets/wiingy_logo.png'
import mulkiLogo from '@/assets/mulki_logo.png'
import workskillsLogo from '@/assets/workskills_logo.png'

export interface BrandsSectionProps {
  className?: string
  id?: string
}

export interface Brand {
  name: string
  category: string
  logoUrl?: string
  logoAlt?: string
}

const brands: Brand[] = [
  { name: 'Properr', category: 'Real Estate', logoUrl: properrLogo, logoAlt: 'Properr' },
  { name: 'Auditzy', category: 'SaaS', logoUrl: auditzyLogo, logoAlt: 'Auditzy' },
  { name: 'Tripture', category: 'Hospitality', logoUrl: triptureLogo, logoAlt: 'Tripture' },
  { name: 'Wiingy', category: 'Ed-Tech', logoUrl: wiingyLogo, logoAlt: 'Wiingy' },
  { name: 'Mulki Surf Club', category: 'Hospitality', logoUrl: mulkiLogo, logoAlt: 'Mulki Surf Club' },
  { name: 'WorkSkills', category: 'Ed-Tech', logoUrl: workskillsLogo, logoAlt: 'WorkSkills' },
]

export const BrandsSection: React.FC<BrandsSectionProps> = ({
  className = '',
  id,
}) => {
  return (
    <section id={id} className={`brands-section ${className}`}>
      <div className="brands-section-backdrop" />
      <div className="brands-section-noise" style={{ backgroundImage: `url(${noiseTexture})` }} />
      <div className="brands-section-content">
        {brands.map((brand, index) => (
          <BrandCard
            key={index}
            name={brand.name}
            category={brand.category}
            logoUrl={brand.logoUrl}
            logoAlt={brand.logoAlt}
          />
        ))}
      </div>
      <div className="brands-section-shadow" />
    </section>
  )
}
